import React from 'react';

export default function ErrorView(): JSX.Element {
  return (
    <div className="h-full w-full flex flex-col items-center">
      <div className="text-[10rem] mt-8">500</div>
      <div className="text-3xl">Something went wrong</div>
    </div>
  );
}
